<template>
    <div>
        <BRow>
            <BCol
                md="6"
                lg="6"
            >
                <BFormGroup :label="nameLabel" label-for="workflow-product-name">
                    <BFormInput
                        id="workflow-product-name"
                        class="input-bg-warning"
                        :value="name"
                        :state="Boolean(name && name.length > 1)"
                        @input="$emit('update:name', $event)"
                    />
                </BFormGroup>
            </BCol>
            <BCol v-if="showCustomerProductNameReference">
                <h6>
                    {{ translate(
                        'Page(ReceivedRequest):Component(Text):product-name-in-request',
                        'Product name in request',
                    ) }}
                </h6>
                <span>{{ customerProduct.name || '—' }}</span>
            </BCol>
        </BRow>
        <BRow>
            <BCol
                md="6"
                lg="6"
            >
                <BFormGroup :label="identifierLabel" label-for="workflow-product-identifier">
                    <BFormInput
                        id="workflow-product-identifier"
                        :value="identifier"
                        @input="$emit('update:identifier', $event)"
                    />
                </BFormGroup>
            </BCol>
            <BCol v-if="showCustomerProductIdentifierReference">
                <h6>
                    {{ translate(
                        'Page(ReceivedRequest):Component(Text):product-id-in-request',
                        'Product ID in request',
                    ) }}
                </h6>
                <span>{{ customerProduct.identifier || '—' }}</span>
            </BCol>
        </BRow>
        <BRow v-if="showDescription">
            <BCol
                md="6"
                lg="6"
            >
                <BFormGroup :label="descriptionLabel" label-for="workflow-product-description">
                    <BFormInput
                        id="workflow-product-description"
                        :value="description"
                        @input="$emit('update:description', $event)"
                    />
                </BFormGroup>
            </BCol>
            <BCol v-if="showCustomerProductDescriptionReference">
                <h6>
                    {{ translate(
                        'Page(ReceivedRequest):Component(Text):product-description-in-request',
                        'Product description in request',
                    ) }}
                </h6>
                <span>{{ customerProduct.description || '—' }}</span>
            </BCol>
        </BRow>
    </div>
</template>

<script>
import {
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
} from 'bootstrap-vue'

export default {
    name: 'WorkflowProductIdentitySection',
    components: {
        BCol,
        BFormGroup,
        BFormInput,
        BRow,
    },
    props: {
        name: { type: String, default: '' },
        identifier: { type: String, default: '' },
        description: { type: String, default: '' },
        nameLabel: { type: String, required: true },
        identifierLabel: { type: String, required: true },
        descriptionLabel: { type: String, required: true },
        customerProduct: { type: Object, default: () => ({}) },
        showDescription: { type: Boolean, default: false },
        showCustomerProductName: { type: Boolean, default: true },
        showCustomerProductIdentifier: { type: Boolean, default: true },
        showCustomerProductDescription: { type: Boolean, default: true },
        showCustomerProductReferenceOnlyWhenDifferent: { type: Boolean, default: false },
    },
    computed: {
        customerProductReferenceDiffers() {
            return this.normalizeReferenceValue(this.name)
                    !== this.normalizeReferenceValue(this.customerProduct.name)
                || this.normalizeReferenceValue(this.identifier)
                    !== this.normalizeReferenceValue(this.customerProduct.identifier)
                || this.normalizeReferenceValue(this.description)
                    !== this.normalizeReferenceValue(this.customerProduct.description)
        },
        showCustomerProductNameReference() {
            return this.showCustomerProductName && this.shouldShowCustomerProductReference
        },
        showCustomerProductIdentifierReference() {
            return this.showCustomerProductIdentifier && this.shouldShowCustomerProductReference
        },
        showCustomerProductDescriptionReference() {
            return this.showDescription
                && this.showCustomerProductDescription
                && this.shouldShowCustomerProductReference
        },
        shouldShowCustomerProductReference() {
            return !this.showCustomerProductReferenceOnlyWhenDifferent
                || this.customerProductReferenceDiffers
        },
    },
    methods: {
        normalizeReferenceValue(value) {
            return String(value || '').trim()
        },
        translate(key, fallback) {
            const translation = this.$t(key)
            return translation && translation !== key ? translation : fallback
        },
    },
}
</script>
